// extracted by mini-css-extract-plugin
export default {"wrapper":"Page404_wrapper__P29VR","container":"Page404_container__JL9F4","title":"Page404_title__8wDCh","backLink":"Page404_backLink__hVXdi","fullScreen":"Page404_fullScreen__h0JmF"};